<template>
  <AperturaCaja />
</template>

<script>
import AperturaCaja from '@/components/cajas/AperturaCaja.vue'
export default {
  name: 'CajasView',
  components: { AperturaCaja }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/CajasView.vue